import React, { useContext } from "react";
import classNames from 'classnames';
import { Card } from '@alifd/next';
import CheckCell from "../check-cell";
import { StaticContext, SelectionContext } from "../contexts";
import { defaultRenderItem } from "../default-props";
import "./index.scss";
function Item(props) {
  var className = props.className,
    _props$index = props.index,
    index = _props$index === void 0 ? 0 : _props$index,
    _props$record = props.record,
    record = _props$record === void 0 ? {} : _props$record,
    header = props.header,
    footer = props.footer,
    children = props.children;
  var _useContext = useContext(StaticContext),
    columns = _useContext.columns;
  var checkCell = /*#__PURE__*/React.createElement(SelectionContext.Consumer, null, function (selection) {
    var enabled = selection.enabled,
      isSelected = selection.isSelected,
      isIndeterminate = selection.isIndeterminate,
      select = selection.select,
      getProps = selection.getProps;
    var handleCheck = function handleCheck(checked) {
      select(checked, record);
    };
    var propsGetter = function propsGetter() {
      return getProps(record, index);
    };
    return enabled && /*#__PURE__*/React.createElement(CheckCell, {
      checked: isSelected(record),
      indeterminate: isIndeterminate(record),
      onChange: handleCheck,
      getProps: propsGetter,
      className: "aplus-auto-exp",
      "data-spm": "d_list_item_check_cell"
    });
  });
  return /*#__PURE__*/React.createElement(Card, {
    "data-spm": props['data-spm'],
    className: classNames('list-item', className),
    free: true
  }, header ? /*#__PURE__*/React.createElement("div", {
    className: "list-item-header"
  }, checkCell, header) : null, /*#__PURE__*/React.createElement("div", {
    className: "list-item-body"
  }, !header && checkCell, /*#__PURE__*/React.createElement("div", {
    className: "list-item-wrapper"
  }, children || defaultRenderItem(record, index, columns))), footer ? /*#__PURE__*/React.createElement("div", {
    className: "list-item-footer"
  }, footer) : null);
}
export default Item;